export default "__VITE_ASSET__7aa23710__"